(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["design-of-week"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DESIGN_WEEK_TIME_ZONE = 'Europe/Berlin';
    var designWeekZonedFormatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: DESIGN_WEEK_TIME_ZONE,
      calendar: 'gregory',
      numberingSystem: 'latn',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function designWeekZonedParts(date) {
      var values = {};
      designWeekZonedFormatter.formatToParts(date).forEach(function (part) {
        if (part.type !== 'literal') values[part.type] = Number(part.value);
      });
      return values;
    }

    function designWeekLocalMidnight(localDate) {
      var targetAsUtc = Date.UTC(localDate.year, localDate.month - 1, localDate.day, 0, 0, 0, 0);
      var candidateMs = targetAsUtc;
      for (var attempt = 0; attempt < 6; attempt += 1) {
        var candidate = designWeekZonedParts(new Date(candidateMs));
        var candidateAsUtc = Date.UTC(
          candidate.year,
          candidate.month - 1,
          candidate.day,
          candidate.hour,
          candidate.minute,
          0,
          0
        );
        var correction = targetAsUtc - candidateAsUtc;
        if (
          correction === 0 &&
          candidate.year === localDate.year &&
          candidate.month === localDate.month &&
          candidate.day === localDate.day &&
          candidate.hour === 0 &&
          candidate.minute === 0
        ) {
          return new Date(candidateMs);
        }
        candidateMs += correction;
      }
      throw new Error('design_week_local_midnight_not_resolvable');
    }

    function nextDesignWeekReset(now) {
      var localNow = designWeekZonedParts(now);
      var localDateMs = Date.UTC(localNow.year, localNow.month - 1, localNow.day);
      var localWeekday = new Date(localDateMs).getUTCDay();
      var daysUntilSunday = (7 - localWeekday) % 7;
      var targetDate = new Date(localDateMs + daysUntilSunday * 24 * 60 * 60 * 1000);
      var target = designWeekLocalMidnight({
        year: targetDate.getUTCFullYear(),
        month: targetDate.getUTCMonth() + 1,
        day: targetDate.getUTCDate()
      });
      if (target <= now) {
        targetDate = new Date(targetDate.getTime() + 7 * 24 * 60 * 60 * 1000);
        target = designWeekLocalMidnight({
          year: targetDate.getUTCFullYear(),
          month: targetDate.getUTCMonth() + 1,
          day: targetDate.getUTCDate()
        });
      }
      return target;
    }

    function roundEndDate(state) {
      var value = state && state.activeWindow && state.activeWindow.endsAt;
      if (!value) return null;
      var target = new Date(value);
      return Number.isNaN(target.getTime()) ? null : target;
    }

    function countdownTargetDate(section, now) {
      var liveEnd = section.getAttribute('data-round-ends-at');
      if (liveEnd) {
        var liveTarget = new Date(liveEnd);
        if (!Number.isNaN(liveTarget.getTime())) return liveTarget;
      }

      return nextDesignWeekReset(now);
    }

    function updateCountdown(section) {
      var now = new Date();
      var target = countdownTargetDate(section, now);
      var remaining = Math.max(0, target.getTime() - now.getTime());
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      var text = days + 'd ' + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
      var textNode = section.querySelector('[data-countdown-text]');
      var daysNode = section.querySelector('[data-countdown-days]');
      if (textNode) textNode.textContent = text;
      if (daysNode) daysNode.textContent = days;
    }

    function syncCountdownTarget(section, state) {
      var target = roundEndDate(state);
      if (target) {
        section.setAttribute('data-round-ends-at', target.toISOString());
      } else {
        section.removeAttribute('data-round-ends-at');
      }
      updateCountdown(section);
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
        return {
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        }[character];
      });
    }

    function filterUrl(params) {
      var url = new URL('/collections/all', window.location.origin);
      (params || []).forEach(function (pair) {
        if (pair && pair[0] && pair[1]) url.searchParams.append(pair[0], pair[1]);
      });
      var previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      return url.pathname + url.search;
    }

    function preservePreviewParam(href) {
      var previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (!previewId || !href) return href;
      try {
        var url = new URL(href, window.location.origin);
        url.searchParams.set('preview_theme_id', previewId);
        return url.pathname + url.search + url.hash;
      } catch (error) {
        return href;
      }
    }

    function parseProductMap(section) {
      var node = section.querySelector('[data-design-week-product-map]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent || '{}');
      } catch (error) {
        return {};
      }
    }

    function formatCount(value) {
      var number = Number(value || 0);
      try {
        return number.toLocaleString();
      } catch (error) {
        return String(number);
      }
    }

    function favoriteUnit(section, count) {
      var label = section.getAttribute('data-favorite-label') || 'favorites';
      return Number(count) === 1 && label.toLowerCase() === 'favorites' ? 'favorite' : label;
    }

    function rowHandle(row) {
      return String((row && (row.product_handle || row.productHandle || row.handle)) || '');
    }

    function rowCount(row) {
      if (!row) return 0;
      if (row.eligible_count != null) return Number(row.eligible_count || 0) || 0;
      if (row.active_count != null) return Number(row.active_count || 0) || 0;
      return Number(row.count || row.favorite_count || 0) || 0;
    }

    function rowTitle(row) {
      return String((row && (row.product_title || row.productTitle || row.title)) || '');
    }

    function rowProduct(row) {
      return row && row.product && typeof row.product === 'object' ? row.product : {};
    }

    function rowValue(row, product, snakeKey, camelKey) {
      if (row && row[snakeKey] != null && row[snakeKey] !== '') return row[snakeKey];
      if (row && camelKey && row[camelKey] != null && row[camelKey] !== '') return row[camelKey];
      if (product && product[snakeKey] != null && product[snakeKey] !== '') return product[snakeKey];
      if (product && camelKey && product[camelKey] != null && product[camelKey] !== '') return product[camelKey];
      return '';
    }

    function mergeRows(rows, productMap) {
      return rows.map(function (row) {
        var handle = rowHandle(row);
        var product = rowProduct(row);
        var info = productMap[handle] || {};
        var title = rowTitle(row) || rowValue(row, product, 'product_title', 'productTitle') || info.title || handle || 'Design contender';
        var url = rowValue(row, product, 'product_url', 'productUrl') || info.url || (handle ? '/products/' + handle : '#');
        var image = rowValue(row, product, 'featured_image_url', 'featuredImageUrl') || info.image || '';
        var thumb = rowValue(row, product, 'thumbnail_image_url', 'thumbnailImageUrl') || info.thumb || image || '';
        return {
          handle: handle,
          title: title,
          url: url,
          image: image,
          thumb: thumb,
          artist: rowValue(row, product, 'artist', 'artist') || rowValue(row, product, 'product_type', 'productType') || info.artist || '',
          artistKey: rowValue(row, product, 'artist_key', 'artistKey') || info.artistKey || '',
          speciesLabel: rowValue(row, product, 'species_label', 'speciesLabel') || info.speciesLabel || '',
          speciesKey: rowValue(row, product, 'species_key', 'speciesKey') || info.speciesKey || '',
          count: rowCount(row)
        };
      }).filter(function (row) {
        return row.handle || row.title;
      });
    }

    function normalizeLiveRows(state, productMap) {
      if (!state || state.ok === false) return [];
      var rawRows = Array.isArray(state.leaderboard) ? state.leaderboard : [];
      if (!rawRows.length && state.leader) rawRows = [state.leader];
      if (!rawRows.length) return [];
      return mergeRows(rawRows, productMap).slice(0, 5);
    }

    function setText(section, selector, value) {
      var node = section.querySelector(selector);
      if (node) node.textContent = value;
    }

    function formatMinimumText(section, state) {
      var template = section.getAttribute('data-minimum-template') || '%count% favorites to qualify';
      var minimum = Number(state && state.minimumEligibleVotes);
      if (!Number.isFinite(minimum) || minimum <= 0) minimum = 5;
      return template.replace('%count%', formatCount(minimum));
    }

    function setMode(section, mode, state) {
      var statusLabel = section.getAttribute('data-preview-status-label') || 'Preview leaderboard';
      if (mode === 'live') {
        statusLabel = section.getAttribute('data-live-status-label') || 'Live favorite count';
      } else if (mode === 'empty') {
        statusLabel = section.getAttribute('data-empty-status-label') || statusLabel;
      }

      setText(section, '[data-design-week-source]', statusLabel);
      setText(section, '[data-design-week-minimum]', formatMinimumText(section, state));
      setText(
        section,
        '[data-design-week-rule-body]',
        mode === 'live'
          ? (section.getAttribute('data-live-rule') || '')
          : (section.getAttribute('data-preview-rule') || '')
      );

      section.classList.toggle('is-live', mode === 'live');
      section.classList.toggle('is-preview', mode !== 'live');
    }

    function currentHandle(section) {
      return String(section.getAttribute('data-current-handle') || '');
    }

    function verifiedCurrentSale(section, state) {
      var spotlight = state && state.currentSpotlight;
      var expectedHandle = currentHandle(section);
      var actualHandle = String(spotlight && spotlight.product_handle || '');
      if (
        !spotlight ||
        spotlight.source !== 'applied_design_week_transition' ||
        spotlight.transition_status !== 'verified' ||
        spotlight.sale_verified !== true ||
        !expectedHandle ||
        actualHandle !== expectedHandle
      ) {
        return null;
      }

      var regularCents = Number(spotlight.price_cents);
      var saleCents = Number(spotlight.sale_price_cents);
      var discountPercent = Number(spotlight.discount_percent);
      var derivedPercent = Math.round(((regularCents - saleCents) * 100) / regularCents);
      if (
        !Number.isInteger(regularCents) ||
        !Number.isInteger(saleCents) ||
        !Number.isInteger(discountPercent) ||
        discountPercent <= 0 ||
        discountPercent >= 100 ||
        regularCents <= 0 ||
        saleCents <= 0 ||
        saleCents >= regularCents ||
        derivedPercent !== discountPercent
      ) {
        return null;
      }

      return { discountPercent: discountPercent };
    }

    function formatMarketMoney(cents, currency) {
      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney === 'function' &&
        typeof window.money_format === 'string' &&
        window.money_format
      ) {
        // Shopify money formats may contain a .money span. This helper feeds
        // textContent, so extract only the formatted text from inert markup.
        var formattedMoney = document.createElement('template');
        formattedMoney.innerHTML = window.Shopify.formatMoney(cents, window.money_format);
        return formattedMoney.content.textContent;
      }

      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: currency
        }).format(cents / 100);
      } catch (_) {
        return (cents / 100).toFixed(2) + ' ' + currency;
      }
    }

    function syncVerifiedCurrentSale(section, state) {
      var sale = verifiedCurrentSale(section, state);
      var price = section.querySelector('.fbp-design-week__price');
      var presentmentSaleCents = Number(section.getAttribute('data-current-price-cents'));
      var presentmentCurrency = String(section.getAttribute('data-current-currency') || '');
      var existingSaleValue = price && price.querySelector('.fbp-design-week__price-now-value');
      var existingSaleText = existingSaleValue ? existingSaleValue.textContent : '';
      if (
        !sale ||
        !price ||
        !Number.isInteger(presentmentSaleCents) ||
        presentmentSaleCents <= 0 ||
        !presentmentCurrency ||
        !existingSaleText
      ) {
        return;
      }

      var presentmentRegularCents = Math.round(
        (presentmentSaleCents * 100) / (100 - sale.discountPercent)
      );
      if (!Number.isInteger(presentmentRegularCents) || presentmentRegularCents <= presentmentSaleCents) return;

      price.classList.remove('fbp-design-week__price--regular');
      price.setAttribute('aria-label', sale.discountPercent + '% off Design of the Week price');
      while (price.firstChild) price.removeChild(price.firstChild);

      var badge = document.createElement('span');
      badge.className = 'fbp-design-week__discount-badge';
      badge.textContent = '-' + sale.discountPercent + '%';

      var stack = document.createElement('span');
      stack.className = 'fbp-design-week__price-stack';
      var before = document.createElement('s');
      before.className = 'fbp-design-week__price-before-value';
      before.textContent = formatMarketMoney(presentmentRegularCents, presentmentCurrency);
      var current = document.createElement('strong');
      current.className = 'fbp-design-week__price-now';
      current.setAttribute('aria-label', 'Design of the Week price');
      var currentValue = document.createElement('span');
      currentValue.className = 'fbp-design-week__price-now-value';
      currentValue.textContent = existingSaleText;
      var label = document.createElement('em');
      label.textContent = 'Design of the Week price';

      current.appendChild(currentValue);
      stack.appendChild(before);
      stack.appendChild(current);
      stack.appendChild(label);
      price.appendChild(badge);
      price.appendChild(stack);
    }

    function raceRows(rows, handle) {
      var current = String(handle || '');
      return rows.filter(function (row) {
        return !current || row.handle !== current;
      });
    }

    function seededRows(productMap) {
      return Object.keys(productMap || {}).map(function (handle) {
        var row = productMap[handle] || {};
        return {
          handle: row.handle || handle,
          title: row.title || handle,
          url: row.url || '#',
          image: row.image || '',
          thumb: row.thumb || '',
          artist: row.artist || '',
          artistKey: row.artistKey || '',
          speciesLabel: row.speciesLabel || '',
          speciesKey: row.speciesKey || '',
          count: Number(row.seedCount || 0) || 0
        };
      }).sort(function (a, b) {
        return b.count - a.count;
      });
    }

    function zeroRaceSeedCounts(rows) {
      return (rows || []).map(function (row) {
        var copy = {};
        Object.keys(row || {}).forEach(function (key) {
          copy[key] = row[key];
        });
        copy.count = 0;
        return copy;
      });
    }

    function fillRaceRows(rows, fallbackRows, limit) {
      var seen = {};
      var filled = [];
      var max = Number(limit || 4);

      function add(row) {
        if (!row || !row.handle || seen[row.handle]) return;
        seen[row.handle] = true;
        filled.push(row);
      }

      (rows || []).forEach(add);
      (fallbackRows || []).forEach(add);
      return filled.slice(0, Number.isFinite(max) && max > 0 ? max : 4);
    }

    function updateChallengerLink(section, rows) {
      var link = section.querySelector('[data-design-week-challenger-link]');
      if (!link) return;
      var handles = (rows || []).map(function (row) {
        return row && row.handle;
      }).filter(Boolean).slice(0, 4);
      if (!handles.length) {
        link.href = preservePreviewParam(section.getAttribute('data-challenger-link') || link.href);
        return;
      }
      link.href = filterUrl([['fbp_handles', handles.join(',')]]);
    }

    function hydrateFilterLinks(section) {
      [
        '[data-design-week-current-artist-link]',
        '[data-design-week-current-species-link]',
        '[data-design-week-challenger-link]'
      ].forEach(function (selector) {
        var link = section.querySelector(selector);
        if (link) link.href = preservePreviewParam(link.getAttribute('href') || link.href);
      });
    }

    function renderRaceLeader(section, leader, gap, isTied, isHolder) {
      if (!leader) return;
      var thumbLink = section.querySelector('[data-design-week-race-thumb-link]');
      var thumbImage = thumbLink ? thumbLink.querySelector('img') : null;
      var normalizedGap = Number(gap);
      if (!Number.isFinite(normalizedGap)) normalizedGap = 0;
      var tied = isTied === true;
      var imageUrl = leader.thumb || leader.image;
      if (thumbLink) {
        // The server renders this anchor inert (aria-hidden, tabindex -1, no href).
        // Re-arm it now that a real leader exists.
        if (leader.url) thumbLink.setAttribute('href', leader.url);
        thumbLink.removeAttribute('aria-hidden');
        thumbLink.removeAttribute('tabindex');
        thumbLink.setAttribute('aria-label', 'View ' + leader.title);
        if (!thumbImage && imageUrl) {
          thumbImage = document.createElement('img');
          thumbImage.setAttribute('loading', 'lazy');
          thumbLink.appendChild(thumbImage);
        }
      }
      if (thumbImage) {
        if (imageUrl) {
          thumbImage.hidden = false;
          thumbImage.src = imageUrl;
          thumbImage.removeAttribute('srcset');
          thumbImage.removeAttribute('sizes');
          thumbImage.alt = leader.title;
          if (thumbLink) thumbLink.classList.remove('is-empty');
        } else {
          thumbImage.hidden = true;
          if (thumbLink) thumbLink.classList.add('is-empty');
        }
      }
      setText(section, '[data-design-week-race-title]', leader.title);
      setText(section, '[data-design-week-favorites]', formatCount(leader.count));
      setText(section, '[data-design-week-favorite-label]', favoriteUnit(section, leader.count));
      // If the design out in front is the one already holding the title, "Leading for next
      // week" is misleading - it is defending, not taking over.
      var raceBadge = tied
        ? (section.getAttribute('data-tie-badge') || 'Tied for next week')
        : (isHolder === true
          ? (section.getAttribute('data-holder-badge') || 'Keeping the title next week')
          : (section.getAttribute('data-leader-badge') || 'Leading for next week'));
      setText(section, '[data-design-week-race-badge]', raceBadge);
      setText(section, '[data-design-week-gap]', tied ? 'Tied' : formatCount(Math.max(0, normalizedGap)));
      setText(section, '[data-design-week-gap-label]', tied ? (section.getAttribute('data-tie-label') || 'for first') : (section.getAttribute('data-lead-label') || 'lead'));
    }

    function renderContenders(section, rows, holderHandle) {
      var list = section.querySelector('[data-design-week-contenders]');
      if (!list || !rows.length) return;

      var maxCount = Math.max(1, rows[0].count || 0);

      list.innerHTML = rows.map(function (row, index) {
        var percent = Math.round((row.count / maxCount) * 100);
        if (row.count > 0 && percent < 8) percent = 8;
        if (percent > 100) percent = 100;
        var rank = row.rank || (index + 1);
        var thumb = row.thumb
          ? '<a href="' + escapeHtml(row.url) + '" class="fbp-design-week__thumb" data-design-week-thumb-link><img src="' + escapeHtml(row.thumb) + '" alt="' + escapeHtml(row.title) + '" loading="lazy" sizes="72px"></a>'
          : '<span class="fbp-design-week__thumb is-empty" aria-hidden="true"></span>';

        return [
          '<li class="fbp-design-week__contender' + (row.count > 0 && row.count === maxCount ? ' is-leading' : '') + '" data-design-week-contender data-handle="' + escapeHtml(row.handle) + '">',
          '<span class="fbp-design-week__rank" data-design-week-rank>' + escapeHtml(rank) + '</span>',
          thumb,
          '<div class="fbp-design-week__contender-copy">',
          '<a href="' + escapeHtml(row.url) + '" data-design-week-contender-title>' + escapeHtml(row.title) + '</a>' + (holderHandle && row.handle === holderHandle ? '<em class="fbp-design-week__holder-note">Current title holder</em>' : ''),
          '<span data-design-week-contender-count>' + formatCount(row.count) + ' ' + escapeHtml(favoriteUnit(section, row.count)) + '</span>',
          '<div class="fbp-design-week__meter" aria-hidden="true"><i style="width: ' + percent + '%;" data-design-week-meter></i></div>',
          '</div>',
          '</li>'
        ].join('');
      }).join('');
    }

    // Two honest outcomes when there is no live leader to show.
    //   'empty'       -> the request worked, nobody has favorited anything yet this week.
    //   'unavailable' -> we could not reach the live count at all.
    // Neither may leave a fabricated leader on screen.
    function renderNoLiveRace(section, reason) {
      var isEmpty = reason === 'empty';
      section.setAttribute('data-race-state', reason);
      setText(section, '[data-design-week-list-label]', isEmpty ? 'New weekly round' : 'Standings unavailable');
      setText(section, '[data-design-week-list-heading]', 'Explore designs to vote for');
      var thumbLink = section.querySelector('[data-design-week-race-thumb-link]');
      var thumbImage = thumbLink ? thumbLink.querySelector('img') : null;

      if (thumbLink) {
        thumbLink.setAttribute('href', '#');
        thumbLink.setAttribute('aria-hidden', 'true');
        thumbLink.setAttribute('tabindex', '-1');
        thumbLink.removeAttribute('aria-label');
        thumbLink.classList.add('is-empty');
      }
      if (thumbImage) thumbImage.hidden = true;

      setText(section, '[data-design-week-race-badge]', isEmpty
        ? (section.getAttribute('data-empty-badge') || 'No favorites yet this week')
        : (section.getAttribute('data-unavailable-badge') || 'Live count unavailable'));
      setText(section, '[data-design-week-race-title]', isEmpty
        ? (section.getAttribute('data-empty-title') || 'Be the first to pick next week’s design')
        : (section.getAttribute('data-unavailable-title') || 'We can’t reach the live favorite count right now'));
      setText(section, '[data-design-week-favorites]', isEmpty ? '0' : '–');
      setText(section, '[data-design-week-favorite-label]', section.getAttribute('data-favorite-label') || 'favorites');
      setText(section, '[data-design-week-gap]', '–');
      setText(section, '[data-design-week-gap-label]', section.getAttribute('data-lead-label') || 'lead');

      // Leave the browsable design rows in place, but never show a rank or a count we
      // do not have.
      var pending = isEmpty ? '0 favorites this week' : 'Count unavailable';
      var rows = section.querySelectorAll('[data-design-week-contender]');
      for (var i = 0; i < rows.length; i += 1) {
        rows[i].classList.remove('is-leading');
        var rank = rows[i].querySelector('[data-design-week-rank]');
        if (rank) rank.textContent = '·';
        var count = rows[i].querySelector('[data-design-week-contender-count]');
        if (count) count.textContent = pending;
        var meter = rows[i].querySelector('[data-design-week-meter]');
        if (meter) meter.style.width = '0%';
      }
    }

    function applyLiveState(section, state, productMap) {
      var rows = normalizeLiveRows(state, productMap);
      syncCountdownTarget(section, state);
      // The endpoint verifies the sale percentage; Shopify Liquid supplies the visitor's
      // presentment-currency sale amount. Never display the endpoint's shop-base USD cents.
      syncVerifiedCurrentSale(section, state);
      var activeCurrentHandle = currentHandle(section);
      var seedRaceRows = zeroRaceSeedCounts(raceRows(seededRows(productMap), activeCurrentHandle));
      // The title holder is a normal contender: its favorites count and it can defend the
      // title. Filtering it out of the LIVE rows made the panel crown whoever came second
      // and call them "Leading for next week". seedRaceRows keeps the filter on purpose, so
      // zero-count padding can never invent the holder at 0 favorites.
      var rowsForRace = rows.slice();
      if (!rows.length) {
        setMode(section, 'empty', state);
        renderNoLiveRace(section, 'empty');
        return;
      }
      var gap = Number(state && state.leaderGap);
      var tied = Boolean(state && state.leaderTied);
      if (!rowsForRace.length) {
        rowsForRace = raceRows(rows, activeCurrentHandle);
      }
      // Pad only up to the number of designs that actually have favorites, so the standings
      // never present a design with 0 favorites as if it were competing.
      var realRows = rowsForRace.filter(function (row) { return Number(row.count || 0) > 0; });
      var linkRows = fillRaceRows(rowsForRace, seedRaceRows, 4);
      var displayRows = realRows.length ? realRows : rowsForRace;
      if (!displayRows.length) {
        setMode(section, 'empty', state);
        renderNoLiveRace(section, 'empty');
        return;
      }
      if (!Number.isFinite(gap) || displayRows[0] !== rows[0]) {
        gap = displayRows[0].count - (displayRows[1] ? displayRows[1].count : 0);
        tied = Boolean(displayRows[0] && displayRows[1] && Number(displayRows[0].count || 0) > 0 && Number(displayRows[0].count || 0) === Number(displayRows[1].count || 0));
      } else if (!tied && displayRows[0] && displayRows[1]) {
        tied = Boolean(Number(displayRows[0].count || 0) > 0 && Number(displayRows[0].count || 0) === Number(displayRows[1].count || 0));
      }

      setMode(section, 'live', state);
      section.setAttribute('data-race-state', 'live');
      setText(section, '[data-design-week-list-label]', 'Leaderboard');
      var listHeading = section.querySelector('[data-design-week-list-heading]');
      if (listHeading) listHeading.textContent = listHeading.getAttribute('data-live-heading') || "Next week's top challengers";
      var leaderIsHolder = Boolean(activeCurrentHandle && displayRows[0] && displayRows[0].handle === activeCurrentHandle);
      renderRaceLeader(section, displayRows[0], gap, tied, leaderIsHolder);
      renderContenders(section, displayRows, activeCurrentHandle);
      updateChallengerLink(section, linkRows.length ? linkRows : displayRows);
    }

    function fetchLiveState(section, productMap) {
      var stateUrl = section.getAttribute('data-state-url');
      if (!stateUrl || !window.fetch) {
        renderNoLiveRace(section, 'unavailable');
        return;
      }
      if (section.designWeekRequestPending) {
        section.designWeekRefreshQueued = true;
        return;
      }
      section.designWeekRequestPending = true;
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 10000);

      fetch(stateUrl, {
        signal: controller.signal,
        cache: 'no-store',
        credentials: 'same-origin',
        headers: { accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('design_week_state_request_failed');
        return response.json();
      }).then(function (body) {
        var state = body && body.state ? body.state : body;
        // A missing or explicitly-failed state is NOT silently ignorable: without this the
        // panel keeps whatever placeholder is on screen and presents it as the standings.
        if (!state || state.ok !== true || !Array.isArray(state.leaderboard)) {
          renderNoLiveRace(section, 'unavailable');
          return;
        }
        applyLiveState(section, state, productMap);
      }).catch(function () {
        // Previously an empty catch, which is exactly what left a fabricated leader on the
        // homepage whenever the app proxy was unreachable.
        renderNoLiveRace(section, 'unavailable');
      }).finally(function () {
        window.clearTimeout(timeout);
        section.designWeekRequestPending = false;
        if (section.designWeekRefreshQueued) {
          section.designWeekRefreshQueued = false;
          fetchLiveState(section, productMap);
        }
      });
    }

    function boot() {
      var sections = document.querySelectorAll('[data-design-week]');
      sections.forEach(function (section) {
        if (section.designWeekBound) return;
        section.designWeekBound = true;
        var productMap = parseProductMap(section);
        hydrateFilterLinks(section);
        updateChallengerLink(section, raceRows(seededRows(productMap), currentHandle(section)));
        setMode(section, 'preview', null);
        updateCountdown(section);
        fetchLiveState(section, productMap);
        document.addEventListener('fbp:customer-profiles:favorite', function (event) {
          if (event.detail && event.detail.ok) fetchLiveState(section, productMap);
        });
        document.addEventListener('visibilitychange', function () {
          if (!document.hidden) fetchLiveState(section, productMap);
        });
        window.addEventListener('pageshow', function (event) {
          if (event.persisted) fetchLiveState(section, productMap);
        });
        window.setInterval(function () {
          if (!document.hidden) fetchLiveState(section, productMap);
        }, 60000);
        window.setInterval(function () {
          updateCountdown(section);
        }, 1000);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
